import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getInvoice, updateInvoice } from "../api/invoices";
import SuccessModal from "../components/SuccessModal";

export default function EditInvoice() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
const [successModal, setSuccessModal] = useState(false);
const [successMessage, setSuccessMessage] = useState("");
const [isError, setIsError] = useState(false);

  const [form, setForm] = useState({
    clientName: "",
    email: "",
    phone: "",
    address: "",
    itemDescription: "",
    quantity: 1,
    rate: "",
    gstRate: 18,
    notes: "",
    status: "",
  });

  useEffect(() => {
  const fetchInvoice = async () => {
    try {
      const { data } = await getInvoice(id);

      const inv = data.invoice; // ✅ IMPORTANT FIX

     // console.log("EDIT INVOICE LOADED:", inv);

      setForm({
        clientName: inv.client?.name || "",
        email: inv.client?.email || "",
        phone: inv.client?.phone || "",
        address: inv.client?.address || "",

        itemDescription: inv.items?.[0]?.description || "",
        quantity: inv.items?.[0]?.quantity || 1,
        rate: inv.items?.[0]?.rate || "",
        gstRate: inv.items?.[0]?.gstRate || 18,

        notes: inv.notes || "",
        status: inv.status || "draft", 
      });

    } catch (err) {
      console.error(err);
      alert("Failed to load invoice");
    } finally {
      setFetching(false);
    }
  };

  fetchInvoice();
}, [id]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await updateInvoice(id, {
        client: {
          name: form.clientName,
          email: form.email,
          phone: form.phone,
          address: form.address,
        },
        items: [
          {
            description: form.itemDescription,
            quantity: Number(form.quantity),
            rate: Number(form.rate),
            gstRate: Number(form.gstRate),
          },
        ],
        notes: form.notes,
        status: form.status, 
      });

      setSuccessMessage(
  "Invoice updated successfully!"
);

setSuccessModal(true);
setIsError(false);
      // alert("Invoice updated successfully!");
      // navigate(`/invoice/${id}`);
    } catch (err) {
      console.error(err);
      // alert(err.response?.data?.message || "Failed to update invoice");
      setIsError(true);
      setSuccessMessage(
  err.response?.data?.message ||
  "Failed to update invoice"
);

setSuccessModal(true);
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div style={{ padding: 40, fontFamily: "sans-serif" }}>
        Loading invoice...
      </div>
    );
  }

  return (
    <>
      <style>{`
        /* SAME UI AS YOUR NEW INVOICE PAGE (UNCHANGED STYLE) */
        * { box-sizing: border-box; }

        :root {
          --bg: #f5f4f0;
          --surface: #ffffff;
          --border: #e8e6e0;
          --ink: #1a1a24;
          --ink-2: #3d3d4f;
          --muted: #8a8a9a;
          --accent: #2d2b69;
          --accent-light: #eeedf8;
        }

        body {
          margin: 0;
          background: var(--bg);
          font-family: 'Sora', sans-serif;
        }

        .shell { display: flex; min-height: 100vh; }

        .sidebar {
          width: 240px;
          background: var(--accent);
          color: white;
          position: fixed;
          height: 100vh;
          padding: 24px 12px;
        }

        .logo { padding: 0 12px 20px; border-bottom: 1px solid rgba(255,255,255,0.1); margin-bottom: 20px; }
        .logo-title { font-size: 22px; font-weight: 700; }
        .logo-sub { font-size: 10px; opacity: 0.5; letter-spacing: 2px; }

        .nav-item {
          display: block;
          padding: 10px 12px;
          border-radius: 10px;
          margin-bottom: 6px;
          color: rgba(255,255,255,0.7);
          text-decoration: none;
        }

        .nav-item:hover { background: rgba(255,255,255,0.12); color: white; }

        .main { margin-left: 240px; flex: 1; padding: 40px; }

        .card {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 20px;
          padding: 28px;
          max-width: 900px;
        }

        .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }

        .field { margin-bottom: 20px; }
        .field.full { grid-column: span 2; }

        .label { font-size: 12px; font-weight: 600; margin-bottom: 8px; display: block; }

        .input, .textarea, .select {
          width: 100%;
          padding: 14px 16px;
          border-radius: 12px;
          border: 1px solid var(--border);
          font-size: 14px;
        }

        .actions { display: flex; gap: 12px; margin-top: 12px; }

        .btn {
          border: none;
          border-radius: 12px;
          padding: 12px 22px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
        }

        .btn-primary { background: var(--accent); color: white; }
        .btn-secondary { background: white; border: 1px solid var(--border); }
      `}</style>
<SuccessModal
  open={successModal}
  title={
    isError
      ? "Update Failed"
      : "Invoice Updated"
  }
  message={successMessage}
  buttonText={
    isError
      ? "Close"
      : "View Invoice"
  }
  isError={isError}
  onClose={() => {

    setSuccessModal(false);

    // ONLY navigate on success
    if (!isError) {
      navigate(`/invoice/${id}`);
    }

  }}
/>
      <div className="shell">
        <aside className="sidebar">
          <div className="logo">
            <div className="logo-title">Invoice AI</div>
            <div className="logo-sub">Edit Invoice</div>
          </div>

          <nav className="sidebar-nav">
                    <Link to="/dashboard" className="nav-item"><span className="nav-icon">▦</span> Dashboard</Link>
                    <Link to="/" className="nav-item"><span className="nav-icon">✨</span> WelcomePage</Link>
                    <Link to="/invoices" className="nav-item"><span className="nav-icon">📄</span> Invoices</Link>
                    <Link to="/invoice/new" className="nav-item"><span className="nav-icon">＋</span> New Invoice</Link>
                    <Link to="/invoice/ai" className="nav-item"><span className="nav-icon">✦</span> AI Generate</Link>
                    <Link to="/settings" className="nav-item"><span className="nav-icon">⚙</span> Settings</Link>
                    <Link to="/billing" className="nav-item"><span className="nav-icon">💳</span> Billing</Link>
                  </nav>
        </aside>

        <main className="main">
          <div className="card">
            <h2>Edit Invoice</h2>

            <form onSubmit={handleSubmit}>
              <div className="grid">

                <div className="field">
                  <label className="label">Client Name</label>
                  <input className="input" name="clientName" value={form.clientName} onChange={handleChange} />
                </div>

                <div className="field">
                  <label className="label">Email</label>
                  <input className="input" name="email" value={form.email} onChange={handleChange} />
                </div>

                <div className="field">
                  <label className="label">Phone</label>
                  <input className="input" name="phone" value={form.phone} onChange={handleChange} />
                </div>

                <div className="field">
                  <label className="label">Address</label>
                  <input className="input" name="address" value={form.address} onChange={handleChange} />
                </div>

                <div className="field full">
                  <label className="label">Item</label>
                  <input className="input" name="itemDescription" value={form.itemDescription} onChange={handleChange} />
                </div>

                <div className="field">
                  <label className="label">Quantity</label>
                  <input className="input" name="quantity" value={form.quantity} onChange={handleChange} />
                </div>

                <div className="field">
                  <label className="label">Rate</label>
                  <input className="input" name="rate" value={form.rate} onChange={handleChange} />
                </div>
<div className="field">
  <label className="label">Status</label>
  <select
    className="input"
    name="status"
    value={form.status}
    onChange={handleChange}
  >
    <option value="draft">Draft</option>
    <option value="sent">Sent</option>
    <option value="paid">Paid</option>
    <option value="overdue">Overdue</option>
    <option value="cancelled">Cancelled</option>
  </select>
</div>
                <div className="field">
                  <label className="label">GST</label>
                  <input className="input" name="gstRate" value={form.gstRate} onChange={handleChange} />
                </div>

                <div className="field full">
                  <label className="label">Notes</label>
                  <textarea className="textarea" name="notes" value={form.notes} onChange={handleChange} />
                </div>

              </div>

              <div className="actions">
                <button className="btn btn-primary" disabled={loading}>
                  {loading ? "Updating..." : "Update Invoice"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate(`/invoice/${id}`)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </>
  );
}